import { useState } from "react";

const FORM_ENDPOINT = "https://formsubmit.co/ajax/info@netrabharat.com";

const BENEFITS = [
  { icon: "fa-percent",    text: "Attractive margins for dealers and distributors" },
  { icon: "fa-book",       text: "Marketing, catalogue and brand support" },
  { icon: "fa-refresh",    text: "Reliable stock availability and replenishment" },
  { icon: "fa-headphones", text: "Dedicated partner support team" },
  { icon: "fa-map",        text: "Territory rights available (subject to terms)" },
  { icon: "fa-tags",       text: "OEM and private label supply on bulk orders" },
  { icon: "fa-globe",      text: "Export support for international buyers — Nepal & more" },
];

const initial = { name: "", company: "", city: "", phone: "", email: "", btype: "" };

export const Distributor = () => {
  const [form, setForm]     = useState(initial);
  const [status, setStatus] = useState({ sending: false, sent: false, error: false });

  const handleChange = (e) => setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ sending: true, sent: false, error: false });
    try {
      const res = await fetch(FORM_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ ...form, _subject: `Partner Enquiry — ${form.company || form.name}` }),
      });
      if (!res.ok) throw new Error();
      setStatus({ sending: false, sent: true, error: false });
      setForm(initial);
    } catch { setStatus({ sending: false, sent: false, error: true }); }
  };

  return (
    <div id="distributor" className="distributor-section">
      <div className="container">
        <div className="section-title">
          <h2>Grow With A Trusted Business Partner</h2>
          <p>We are actively expanding our partner network across India and international markets. Join us to bring quality consumer products to your region — with full business support.</p>
        </div>

        <div className="export-banner">
          <i className="fa fa-globe" aria-hidden="true"></i>
          <div>
            <strong>Exporters & International Buyers Welcome</strong>
            <span>We supply to Nepal and other international markets. Export documentation and bulk packaging available on request.</span>
          </div>
        </div>

        <div className="row">
          <div className="col-md-5">
            <h3 className="dist-sub-title">Why Partner With Us</h3>
            <ul className="dist-benefits">
              {BENEFITS.map((b, i) => (
                <li key={i}><i className={`fa ${b.icon}`} aria-hidden="true"></i>{b.text}</li>
              ))}
            </ul>
            <div className="dist-who">
              <h4>Who Can Partner With Us</h4>
              <div className="dist-tags">
                {["Retail Dealers","Regional Distributors","Hardware & Kitchen Stores","E-commerce Sellers","Modular Kitchen Brands","Hospitality & Institutional","Exporters & Trading Houses","International Buyers — Nepal & More","Corporate Procurement Teams"].map((t, i) => (
                  <span key={i} className="dist-tag">{t}</span>
                ))}
              </div>
            </div>
          </div>

          <div className="col-md-6 col-md-offset-1">
            <div className="dist-form-wrap">
              <h3 className="dist-sub-title">Send Your Enquiry</h3>
              {status.sent ? (
                <div className="alert alert-success" role="alert">
                  <i className="fa fa-check-circle"></i> Thank you! We will contact you within 24 business hours.
                </div>
              ) : (
                <form onSubmit={handleSubmit} noValidate>
                  <div className="row">
                    <div className="col-sm-6">
                      <label htmlFor="d-name">Your Name *</label>
                      <input id="d-name" className="form-control" name="name" placeholder="Full name" required value={form.name} onChange={handleChange} aria-required="true" />
                    </div>
                    <div className="col-sm-6">
                      <label htmlFor="d-company">Company Name</label>
                      <input id="d-company" className="form-control" name="company" placeholder="Your company" value={form.company} onChange={handleChange} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <label htmlFor="d-city">City / Country *</label>
                      <input id="d-city" className="form-control" name="city" placeholder="City or Country" required value={form.city} onChange={handleChange} aria-required="true" />
                    </div>
                    <div className="col-sm-6">
                      <label htmlFor="d-phone">Phone / WhatsApp *</label>
                      <input id="d-phone" className="form-control" name="phone" type="tel" placeholder="+91 ..." required value={form.phone} onChange={handleChange} aria-required="true" />
                    </div>
                  </div>
                  <label htmlFor="d-email">Email Address *</label>
                  <input id="d-email" className="form-control" name="email" type="email" placeholder="you@company.com" required value={form.email} onChange={handleChange} aria-required="true" />
                  <label htmlFor="d-btype">Business Type</label>
                  <select id="d-btype" className="form-control" name="btype" value={form.btype} onChange={handleChange}>
                    <option value="">Select your business type</option>
                    <option>Retailer / Dealer</option>
                    <option>Regional Distributor</option>
                    <option>E-commerce Seller</option>
                    <option>Institutional / Hospitality</option>
                    <option>Exporter / International Buyer</option>
                    <option>OEM / Private Label</option>
                    <option>Corporate Procurement</option>
                    <option>Other</option>
                  </select>
                  {status.error && (
                    <div className="alert alert-danger" role="alert">
                      <i className="fa fa-exclamation-circle"></i> Something went wrong. Please WhatsApp us at +91 1141681813.
                    </div>
                  )}
                  <button type="submit" className="btn btn-custom" disabled={status.sending}>
                    {status.sending ? <span><i className="fa fa-spinner fa-spin"></i> Sending...</span> : "Submit Enquiry"}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
